export const PREPARA_EPISODIO = "PREPARA_EPISODIO";
export const ALTERA_STATUS_REPRODUCAO_IFRAME =
  "ALTERA_STATUS_REPRODUCAO_IFRAME";
